import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  packageDocId: string;
}

const mutateDeleteOCPClosingDocument = async ({
  ocpId,
  packageDocId,
}: mutateProps) => {
  return await axiosAuth.delete(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/documents/${packageDocId}/file`
  );
};

const useDeleteOCPClosingDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteOCPClosingDocument,
    ...queryParams,
  });

export default useDeleteOCPClosingDocumentMutation;
